import { FC } from 'react';

const Wallet: FC = () => {
  return <>Wallet</>;
};

export default Wallet;
